export const getHomeUrl = () => {
  const building = localStorage.getItem('building') || 'MS-GANGNAM';
  const floor = localStorage.getItem('floor') || '2';
  return `/?b=${building}&f=${floor}`;
};
